import {
    ErrorRemovingProviderTitleText,
    ErrorRemovingProviderDescriptionText,
} from './removeFileProvider.locstring.json';
import loc, { format } from 'owa-localize';
import getProviderBrandName from '../utils/getProviderBrandName';
import { logUsage } from 'owa-analytics';
import { clearFileProviderToken } from 'owa-fileprovider-items-service';
import { confirm } from 'owa-confirm-dialog';
import { fileProviderRemoved } from '../actions/subscribableActions';
import { FileProviderType } from '../utils/constants';
import { orchestrator } from 'satcheljs';
import { remove } from '../actions/internalActions';
import { removeFileProvider } from '../actions/publicActions';
import { trace } from 'owa-trace';
import { getFileProvider } from '../selectors/getFileProviders';
import isFileProviderAddable from '../utils/isFileProviderAddable';
import RemoveAttachmentDataProviderResponse from 'owa-service/lib/contract/RemoveAttachmentDataProviderResponse';
import removeFileProviderService from '../services/removeFileProvider';

orchestrator(removeFileProvider, actionMessage => {
    removeFileProviderOrchestrator(actionMessage.providerType);
});

export default async function removeFileProviderOrchestrator(providerType: FileProviderType) {
    const provider = getFileProvider(providerType.toString());

    if (!provider || !isFileProviderAddable(providerType)) {
        handleError(
            'Unable to remove the provider as the provider does not exist in the store or is not addable.',
            providerType
        );
        logUsage('FPRemoveFileProvider', {
            message: 'Provider does not exist in the store or is not addable.',
            fileProviderType: providerType.toString(),
        });
        return;
    }
    const removeResponse: RemoveAttachmentDataProviderResponse = await removeFileProviderService(
        provider.model.Id
    );

    if (!removeResponse.RemovedSuccessfuly) {
        handleError('Unable to remove the provider', provider.type);
        logUsage('FPRemoveFileProvider', {
            message: 'Unable to remove the provider',
            fileProviderType: providerType.toString(),
        });
    } else {
        remove(providerType);
        fileProviderRemoved(providerType);
        // When we remove the provider we clear any
        // associated token (if any) so that if the user
        // adds the provider again we use the new token
        clearFileProviderToken(provider.type);
        logUsage('FPRemoveFileProvider', {
            message: 'Successfully removed file provider',
            fileProviderType: providerType.toString(),
        });
    }
}

function handleError(errorMessage: string, providerType: FileProviderType) {
    trace.warn(`Error in removing file provider ${errorMessage}`);
    showRemoveProviderErrorDialog(getProviderBrandName(providerType));
}

function showRemoveProviderErrorDialog(providerDisplayName: string) {
    confirm(
        loc(ErrorRemovingProviderTitleText),
        format(loc(ErrorRemovingProviderDescriptionText), providerDisplayName),
        false,
        {
            hideCancelButton: true,
        }
    );
}
